import { useCallback, useState } from 'react';
import useSocialShareConnectedModal from './useSocialShareConnectedModal';

export interface UseSocialShareScheduleResult {
  scheduledDate: number | undefined;
  isSchedulingPost: boolean;
  onScheduledDateChange: (date: number) => void;
  schedulePost: (scheduleFn: () => Promise<void>) => Promise<void>;
}

export default function useSocialShareSchedule(): UseSocialShareScheduleResult {
  const [scheduledDate, setScheduledDate] = useState<number | undefined>(
    undefined,
  );
  const [isSchedulingPost, setIsSchedulingPost] = useState(false);

  const { onHide } = useSocialShareConnectedModal();

  const handleScheduleFinished = useCallback(() => {
    setIsSchedulingPost(false);
    onHide();
  }, [onHide]);

  const handleSchedule = useCallback(
    async (scheduleFn: () => Promise<void>): Promise<void> => {
      try {
        setIsSchedulingPost(true);

        await scheduleFn();
      } finally {
        handleScheduleFinished();
      }
    },
    [handleScheduleFinished],
  );

  return {
    scheduledDate,
    isSchedulingPost,
    onScheduledDateChange: setScheduledDate,
    schedulePost: handleSchedule,
  };
}
